<div style="display: flex; flex-direction: column; align-items: center; width: 100%; height: 100%">
    <div [innerHTML]="summary"></div>
    <div style="width: 75%; height: 100%">
        @if (loading) {
            <div class="loading"></div>
        }

        @if (previewUrl) {
            <iframe
                [src]="previewUrl"
                width="100%"
                height="100%"
                title="Check document preview"
                style="border: none; width: 100%; height: 100%"
                allow="fullscreen"></iframe>
        }

        @if (loadError) {
            <p style="margin-top: 1rem; color: #666">PDF preview not available.</p>
        }
    </div>
</div>
